<!--suppress XmlInvalidId, HtmlUnknownBooleanAttribute, AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">
      <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </a></li>
    <li class="breadcrumb-item"><a href="javascript:void(0);" translate>Products</a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>New Product</li>
    <li class="breadcrumb-item">
      <a href="https://www.youtube.com/watch?v=c6fjRd8AWhI" target="_blank">
        <svg width="15" height="15" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
          <g id="Group">
            <path id="Path" fill="#06209f" stroke="none"
                  d="M 683.015686 117.331543 C 526.902344 -38.973694 273.638733 -39.129089 117.331566 116.982361 C -38.973663 273.097717 -39.130989 526.363159 116.984306 682.670349 C 273.095764 838.975586 526.36322 839.130981 682.670349 683.017639 C 838.973694 526.906128 839.130981 273.636841 683.015686 117.331543 Z M 455.850311 653.819031 C 455.850311 659.991028 450.848602 664.988892 444.68042 664.988892 L 355.321472 664.988892 C 349.15332 664.988892 344.151642 659.991028 344.151642 653.819031 L 344.151642 322.097748 C 344.151642 315.925751 349.15332 310.927887 355.321472 310.927887 L 444.68042 310.927887 C 450.848602 310.927887 455.850311 315.923828 455.850311 322.097748 L 455.850311 653.819031 Z M 400.000977 264.571594 C 364.281158 264.571594 335.218811 235.513062 335.218811 199.791382 C 335.218811 164.073486 364.279266 135.009216 400.000977 135.009216 C 435.722656 135.009216 464.783112 164.071594 464.783112 199.791382 C 464.783112 235.513062 435.718811 264.571594 400.000977 264.571594 Z"/>
          </g>
          <g id="g1"/>
        </svg>
      </a>
    </li>
  </ol>
</nav>
<form [hidden]="loading" [formGroup]="productForm" class="w-100" novalidate action="javascript:void(0);">
  <div class="container bg-white border-secondary shadow border-primary p-3 m-3">
    <div class="form-row">
      <div class="col-md-12 mb-4">
        <label for="title" translate>Title</label>
        <input [ngClass]="{'is-invalid': submitted && f.title.errors }" type="text" formControlName="title" class="form-control" id="title" placeholder="{{'Title' | translate}}">
        <div *ngIf="submitted && f.title.errors && f.title.errors.required" class="invalid-feedback" translate>
          Required field
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-12 mb-4 form-group">
        <label for="description" translate>Description</label>
        <textarea formControlName="description" class="form-control" id="description" rows="3"></textarea>
      </div>
    </div>
  </div>
  <div class="container bg-white border-secondary shadow border-primary p-3 m-3">
    <div class="form-row">
      <div class="col-md-6 mb-4">
        <label for="price" translate>Price</label>
        <input [ngClass]="{'is-invalid' : submitted && f.price.errors}" type="text" formControlName="price" class="form-control" id="price" placeholder="{{'Price' | translate}}">
        <div *ngIf="submitted && f.price.errors && f.price.errors.required" class="invalid-feedback" translate>
          Required field
        </div>
        <div *ngIf="submitted && f.price.errors && f.price.errors.pattern" class="invalid-feedback" translate>
          Invalid value
        </div>
      </div>
      <div class="col-md-6 mb-4">
        <label for="qty" translate>Qty</label>
        <input [ngClass]="{'is-invalid' : submitted && f.qty.errors}" formControlName="qty" type="text" class="form-control" id="qty" placeholder="{{'Qty' | translate}}">
        <div *ngIf="submitted && f.qty.errors && f.qty.errors.required" class="invalid-feedback" translate>
          Required field
        </div>
        <div *ngIf="submitted && f.qty.errors && f.qty.errors.pattern" class="invalid-feedback" translate>
          Invalid value
        </div>
      </div>
    </div>
  </div>
  <div class="container bg-white border-secondary shadow border-primary p-3 m-3">
    <div class="row my-2">
      <div class="col-12">
        <input [ngClass]="{'is-invalid' : submitted && f.digital.errors}" formControlName="digital" type="checkbox" id="digital">&nbsp;&nbsp;
        <label for="qty" translate>Is Digital Product</label>
        <div *ngIf="submitted && f.digital.errors && f.digital.errors.required" class="invalid-feedback" translate>
          Required field
        </div>
        <div *ngIf="submitted && f.digital.errors && f.digital.errors.pattern" class="invalid-feedback" translate>
          Invalid value
        </div>
      </div>
    </div>
  </div>
  <div class="container bg-white border-secondary shadow border-primary p-3 m-3">
    <div class="form-row">
      <div class="col-md-12 mb-2 form-group border-danger border-width-3px">
        <div class="custom-file-container" data-upload-id="mainProductImage">
          <label>{{ 'Main Product Image' | translate }} <span style="font-size: 7pt">(1600px X 900px)</span>
            <a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image">x</a>
          </label>
          <label class="custom-file-container__custom-file">
            <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="image/*">
            <input type="hidden" name="MAX_FILE_SIZE" value="2097152"/>
            <span class="custom-file-container__custom-file__custom-file-control"></span>
          </label>
          <pintura-editor #mainProductEditor *ngIf="productMainUrl != null" [src]="productMainUrl"
                          [options]="productMainPinturaOptions" [imageCropAspectRatio]="16 / 9" (loadstart)="imageLoadStart($event)"
                          (load)="imageLoaded($event)" (loadprogress)="imageLoadProgress($event)" (loadpreview)="imageLoadPreview($event)"
                          (process)="handleEditorProcess($event)"
          ></pintura-editor>
          <div *ngIf="loadingMainPictures" class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
          <div [hidden]="loadingMainPictures || productMainUrl != null" class="custom-file-container__image-preview"></div>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-12 mb-2 form-group border-danger border-width-3px">
        <div class="custom-file-container" data-upload-id="thumbnailProductImage">
          <label>{{ 'Thumbnail Product Image' | translate }} <span style="font-size: 7pt">(300px X 300px)</span><a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image">x</a></label>
          <label class="custom-file-container__custom-file" [hidden]="true">
            <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="image/*">
            <input type="hidden" name="MAX_FILE_SIZE" value="2097152"/>
            <span class="custom-file-container__custom-file__custom-file-control"></span>
          </label>
          <pintura-editor #thumbnailProductEditor *ngIf="productThumbnailUrl != null" [src]="productThumbnailUrl"
                          [options]="productThumbnailPinturaOptions" [imageCropAspectRatio]="1"
                          (process)="handleEditorProcess($event)">
          </pintura-editor>
          <div *ngIf="loadingThumbnailPictures" class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
          <div [hidden]="loadingThumbnailPictures || productThumbnailUrl" class="custom-file-container__image-preview"></div>
          <!--          <div *ngIf="thumbnailPictureHeight && thumbnailPictureWidth && (thumbnailPictureHeight != 300 || thumbnailPictureWidth != 300)" class="text-danger" translate>The picture size is not 300x300 pixels. Therefore, it may not be displayed appropriately to clients.</div>-->
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-12 mb-2 form-group border-danger border-width-3px">
        <div class="custom-file-container" data-upload-id="gridProductImage">
          <label>{{ 'Grid Product Image' | translate }} <span style="font-size: 7pt">(1200px X 1200px)</span><a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image">x</a></label>
          <label class="custom-file-container__custom-file" [hidden]="true">
            <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="image/*">
            <input type="hidden" name="MAX_FILE_SIZE" value="2097152"/>
            <span class="custom-file-container__custom-file__custom-file-control"></span>
          </label>
          <pintura-editor #gridProductEditor *ngIf="productGridUrl" [src]="productGridUrl"
                          [options]="productGridPinturaOptions" [imageCropAspectRatio]="1"
                          (process)="handleEditorProcess($event)"></pintura-editor>
          <div *ngIf="loadingGridPictures" class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
          <div [hidden]="loadingGridPictures || productGridUrl" class="custom-file-container__image-preview"></div>
          <!--          <div *ngIf="gridPictureHeight && gridPictureWidth && (gridPictureHeight != 1200 || gridPictureWidth != 1200)" class="text-danger" translate>The picture size is not 1200x1200 pixels. Therefore, it may not be displayed appropriately to clients.</div>-->
        </div>
      </div>
    </div>
  </div>
  <div class="container bg-white border-secondary shadow border-primary p-3 m-3">


    <div class="form-row">
      <div class="col-md-12 mb-2 form-group border-danger border-width-3px">
        <div class="w-100 d-flex justify-content-between">
          <label translate>Manage Promotion Coupons</label>
          <!-- Add icon button circle plus -->
          <button class="btn btn-primary btn-circle rounded-circle mx-2 " type="button" (click)="addPromotionCoupon()">
            ＋
          </button>
        </div>
        <table class="table my-3">
          <thead>
          <tr>
            <th scope="col" translate>Coupon Code</th>
            <th scope="col" translate>Discount Amount</th>
            <th scope="col" translate>Validity Period</th>
            <th scope="col" translate>Minimum Order Amount</th>
            <th scope="col" translate>Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let coupon of this.coupons">
            <td>{{ coupon.couponCode }}</td>
            <td>{{ coupon.discountAmount }} {{ coupon.discountType == 'percentage' ? '%' : (coupon.discountType == 'fixed' ? "SR" : '') }}</td>

            <td>{{ (coupon.validityPeriod == 'unlimited' ? 'Unlimited' : coupon.startDate + ' - ' + coupon.endDate) | translate }}</td>
            <td>{{ coupon.minOrderAmount ? coupon.minOrderAmount + '' : '' }}</td>
            <td>
              <a href="javascript:void(0)" class="btn btn-danger btn-circle rounded-circle mx-2" title="Delete" (click)="removePromotionCoupon(coupon)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                  <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0"/>
                </svg>
              </a>
              <a href="javascript:void(0)" class="btn btn-primary btn-circle rounded-circle mx-2" title="Edit" (click)="editPromotionCoupon(coupon)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 16">
                  <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z"/>
                </svg>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="container bg-white border-secondary shadow border-primary p-3 m-3">
    <button class="btn btn-primary" type="submit" *ngIf="!isAccountant" (click)="submitForm()" translate>Submit</button>&nbsp;
    <button class="btn btn-light-danger" type="submit" [routerLink]="['/private','products']" [queryParams]="{type: subAccountType, govId: subAccountGovId}" translate>Close</button>
  </div>
</form>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
<!-- write the modal code here for the coupon code -->
<!-- Button to Open the Modal -->
<!-- Modal -->
<div class="modal fade" id="couponModal" #couponModal tabindex="-1" aria-labelledby="couponModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="couponModalLabel" translate>Add/Edit Coupon</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body">
        <form id="couponForm" [formGroup]="couponForm">
          <!-- Coupon Code -->
          <div class="mb-3">
            <label for="couponCode" class="form-label" translate>Coupon Code</label>
            <div class="input-group">
              <input type="text" formControlName="couponCode" class="form-control" id="couponCode"
                     [placeholder]="'Enter coupon code' | translate" required
                     [ngClass]="{'is-invalid':this.couponFormSubmitted &&  couponForm.controls.couponCode.errors }"
                     [disabled]="couponForm.controls.id.value != null" [readOnly]="couponForm.controls.id.value != null">
              <button *ngIf="!couponForm.controls.id.value" type="button" class="btn btn-secondary" id="generateCode" (click)="generateRandomCode()" translate>Generate</button>
            </div>
          </div>

          <!-- Discount Type -->
          <div class="mb-3">
            <div class="form-group">
              <label for="discountType" class="form-label" translate>Discount Type</label>
              <div class="input-group">
                <select class="form-control" formControlName="discountType" id="discountType" style="padding:0" [ngClass]="{'is-invalid': this.couponFormSubmitted && couponForm.controls.discountType.errors }">
                  <option value="percentage" translate>Percentage</option>
                  <option value="fixed" translate>Fixed Amount</option>
                </select>
                <!--                <span *ngIf="this.couponFormSubmitted && couponForm.controls.discountType.errors" class="invalid-feedback" translate>{{ JSON.stringify(couponForm.controls.discountType.errors) }}</span>-->
              </div>
            </div>
          </div>

          <!-- Discount Amount -->
          <div class="mb-3">
            <label for="discountAmount" class="form-label" translate>{{ 'Discount Amount' | translate }}</label>
            <input type="number" formControlName="discountAmount" class="form-control" id="discountAmount" [placeholder]="'Enter discount amount' | translate" [ngClass]="{'is-invalid': this.couponFormSubmitted && couponForm.controls.discountAmount.errors }">
          </div>

          <!-- Validity Period -->
          <div class="mb-3">
            <label for="validityPeriod" class="form-label" translate>Validity Period</label>
            <div class="input-group">
              <select class="form-control" (change)="checkDateRangeControls()" formControlName="validityPeriod" id="validityPeriod" style="padding:0" [ngClass]="{'is-invalid': this.couponFormSubmitted && couponForm.controls.validityPeriod.errors }">
                <option value="unlimited" translate>Unlimited</option>
                <option value="date-range" translate>A Date Range</option>
              </select>
            </div>
            <div class="d-flex justify-content-between my-1" *ngIf="couponForm.controls.validityPeriod.value == 'date-range'">
              <div class="form-group">
                <label for="startDate" class="form-label" translate>Start Date</label>
                <input #startDate formControlName="startDate" placeholder="YYYY/MM/DD" class="form-control me-2" id="startDate" [ngClass]="{'is-invalid': this.couponFormSubmitted && couponForm.controls.startDate.errors }">
              </div>
              <div class="form-group">
                <label for="startDate" class="form-label" translate>End Date</label>
                <input #endDate formControlName="endDate" placeholder="YYYY/MM/DD" class="form-control" id="endDate" [ngClass]="{'is-invalid': this.couponFormSubmitted && couponForm.controls.endDate.errors }">
              </div>
            </div>
          </div>

          <!-- Minimum Order Amount -->
          <div class="mb-3">
            <label for="minOrderAmount" class="form-label" translate>Minimum Order Amount</label>
            <input type="number" formControlName="minOrderAmount" class="form-control" id="minOrderAmount" [placeholder]="'Enter minimum order amount' | translate">
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary" form="couponForm" (click)="savePromotionCoupon()" *ngIf="!submittingCoupon" translate>Save Coupon</button>
        <div *ngIf="submittingCoupon" class="mx-auto spinner-grow text-info loader-lg"></div>
        <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close" *ngIf="!submittingCoupon" translate>Close</button>
        <button *ngIf="couponForm.controls.id.value && !submittingCoupon" type="submit" class="btn btn-danger" form="couponForm" (click)="deletePromotionCoupon()" translate>Delete Coupon</button>
      </div>
    </div>
  </div>
</div>
